import Interno from "./Interno";

export default Interno;
